import { z } from 'zod'

/**
 * Whether a package's price is shown to whoever sees the profile, or is "price
 * on request", which stores no price at all. Mirrors the Prisma
 * `VendorPriceVisibility` enum (`check:enums`).
 */
export const VENDOR_PRICE_VISIBILITIES = ['shown', 'on_request'] as const

export const vendorPriceVisibilitySchema = z.enum(VENDOR_PRICE_VISIBILITIES)

export type VendorPriceVisibility = z.infer<typeof vendorPriceVisibilitySchema>
